import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../../service/user.service';
import { NgbModal, NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ViwProjectModel } from '../../../../models/viwProject.model';
import { ConfigService } from './../../../../service/config.service';
import { ListViwClusterModel } from '../../../../models/listViwCluster.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ProjectService } from '../../../../service/project.service';
import { ModifyProgettoINModel } from '../../../../models/modifyProgettoIN.model';
import { ColumnMode } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import { DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { forkJoin, interval, Subject } from 'rxjs';
import { TabProfileModel } from '../../../../models/tabProfile.model';
import { AssociateUserPrjIN } from '../../../../models/associate-user-prj-in.model';
import { LoadUserProjectIN } from '../../../../models/load-user-project-in.model';
import { ViwUserProfileMobilePrj } from '../../../../models/viw-user-profile-mobile-prj.model';
import { ViwUserProfileMobile } from '../../../../models/viw-user-profile-mobile.model';
import { RelProgettoStatiIN } from '../../../../models/rel-progetto-stati-in.model';
import { LoadComuniINModel } from '../../../../models/loadComuniIN.model';
import { MapService } from 'src/app/service/map.service';
import { ViwRelProgettoStati } from '../../../../models/viw-rel-progetto-stati.model';
import { ViwStati } from '../../../../models/viw-stati.model';
import { ViwFolderTree } from '../../../../models/viw-folder-tree.model';
import { DmsService } from '../../../../service/dms.service';
import { DeleteFileINModel } from '../../../../models/delete-file-inmodel.model';
import { ViwLayerModel } from 'src/app/models/viwLayer.model';
import { LoadListFileIN } from '../../../../models/load-list-file-in.model';
import { RelProjectFolder } from '../../../../models/rel-project-folder.model';
import { UploadFileINModel } from '../../../../models/upload-file-inmodel.model';
import { LoadFileINModel } from '../../../../models/load-file-inmodel.model';
import { StampaModelloOtticaIN } from '../../../../models/stampa-modello-ottica-in.mdel';
import { StampaModelloRameIN } from '../../../../models/stampa-modello-rame-in.model';
import { StampaModelloPreventivoIN } from '../../../../models/stampa-modello-preventivo-in.model';
import { skipWhile, switchMap, takeWhile } from 'rxjs/operators';
import { ReportService } from 'src/app/service/report.service';
import { InsertPlanimetriaOUTModel } from 'src/app/models/insertPlanimetriaOUT.model';
import { ReportStatusOUTModel } from 'src/app/models/reportStatusOUT.model';
import { DowloadPrintOUTModel } from 'src/app/models/dowloadPrintOUT.model';
import { PrintSinotticoOUTModel } from 'src/app/models/printSinotticoOUT.model';
import { ExportCatalogoINModel } from 'src/app/models/exportCatalogoIN.model';
import { DownloadMisureINModel } from 'src/app/models/downloadMisureIN.model';


@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.scss']
})
export class ProjectDetailComponent implements OnInit {

  // dataSource
  public data: ViwFolderTree[] = [
    //  {"livello":1,"cartella":"ROOT","idPadre":null,"idFiglio":0,"chiave":0,"patCur":"/0/","pathLogico":"/ROOT/","flgFigli":true,"uuid":"6ACA81C5BA1E4783A92C4185863C0B06"},{"livello":2,"cartella":"  GENERALE","idPadre":0,"idFiglio":1,"chiave":1,"patCur":"/0/7/","pathLogico":"/ROOT/GENERALE/","flgFigli":false,"uuid":"5E4768090AE148D3A7C26D82F903A26E"},{"livello":2,"cartella":"  PROGETTO_ESECUTIVO","idPadre":0,"idFiglio":2,"chiave":2,"patCur":"/0/16/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/","flgFigli":true,"uuid":"03DDDD3B043F48878F619BC6DB3C610F"},{"livello":3,"cartella":"    OUTPUT","idPadre":2,"idFiglio":7,"chiave":7,"patCur":"/0/16/12/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/OUTPUT/","flgFigli":true,"uuid":"5AB37985FD5E466882FE19DC7135BBC6"},{"livello":4,"cartella":"      PLANIMETRIA","idPadre":7,"idFiglio":8,"chiave":8,"patCur":"/0/16/12/14/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/OUTPUT/PLANIMETRIA/","flgFigli":false,"uuid":"11517528EB9F4E26830E165620C401D9"},{"livello":4,"cartella":"      SINOTTICO","idPadre":7,"idFiglio":9,"chiave":9,"patCur":"/0/16/12/20/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/OUTPUT/SINOTTICO/","flgFigli":false,"uuid":"A504D126942C43A593D94279A9E1A832"},{"livello":4,"cartella":"      QUANTITA_ELENCO_MATERIALI","idPadre":7,"idFiglio":10,"chiave":10,"patCur":"/0/16/12/17/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/OUTPUT/QUANTITA_ELENCO_MATERIALI/","flgFigli":false,"uuid":"4F0BEA9AD97A4F6480AF27E26DC36A8E"},{"livello":4,"cartella":"      TABELLA_SINTESI","idPadre":7,"idFiglio":11,"chiave":11,"patCur":"/0/16/12/22/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/OUTPUT/TABELLA_SINTESI/","flgFigli":false,"uuid":"92CA3D15C55F4F2882EF1A6DE52F2AA1"},{"livello":4,"cartella":"      AREE_INFLUENZA","idPadre":7,"idFiglio":12,"chiave":12,"patCur":"/0/16/12/2/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/OUTPUT/AREE_INFLUENZA/","flgFigli":false,"uuid":"F9E33A2F48E142E6B11B5883A2793196"},{"livello":4,"cartella":"      AGG_TERMINALI_RAME","idPadre":7,"idFiglio":13,"chiave":13,"patCur":"/0/16/12/1/","pathLogico":"/ROOT/PROGETTO_ESECUTIVO/OUTPUT/AGG_TERMINALI_RAME/","flgFigli":false,"uuid":"99C14B51EBC04883B0D81D2415CBA7A5"},{"livello":2,"cartella":"  PERMESSI","idPadre":0,"idFiglio":3,"chiave":3,"patCur":"/0/13/","pathLogico":"/ROOT/PERMESSI/","flgFigli":true,"uuid":"ADE7953403E44CB4847A8BAEA0081682"},{"livello":3,"cartella":"    ISTANZE","idPadre":3,"idFiglio":14,"chiave":14,"patCur":"/0/13/9/","pathLogico":"/ROOT/PERMESSI/ISTANZE/","flgFigli":false,"uuid":"F6A4F1F2FD14408F80F66BC6A879E5E3"},{"livello":3,"cartella":"    RICHIESTE_INTEGRAZIONI","idPadre":3,"idFiglio":15,"chiave":15,"patCur":"/0/13/19/","pathLogico":"/ROOT/PERMESSI/RICHIESTE_INTEGRAZIONI/","flgFigli":false,"uuid":"F588D1B6CE034EB6B69CFD923727B935"},{"livello":3,"cartella":"    AUTORIZZAZIONI","idPadre":3,"idFiglio":16,"chiave":16,"patCur":"/0/13/4/","pathLogico":"/ROOT/PERMESSI/AUTORIZZAZIONI/","flgFigli":false,"uuid":"89A06AB4114441E899D5E2706CCE59C7"},{"livello":3,"cartella":"    VARIE","idPadre":3,"idFiglio":17,"chiave":17,"patCur":"/0/13/24/","pathLogico":"/ROOT/PERMESSI/VARIE/","flgFigli":false,"uuid":"E548AC196EC04F819BEC43496271B3AF"},{"livello":2,"cartella":"  IRU","idPadre":0,"idFiglio":4,"chiave":4,"patCur":"/0/8/","pathLogico":"/ROOT/IRU/","flgFigli":true,"uuid":"020537046AB74B81AAB73B2996BABA33"},{"livello":3,"cartella":"    DATI","idPadre":4,"idFiglio":18,"chiave":18,"patCur":"/0/8/5/","pathLogico":"/ROOT/IRU/DATI/","flgFigli":false,"uuid":"666CF1F3B6464F99AB18012655A4C8C7"},{"livello":3,"cartella":"    RICHIESTE","idPadre":4,"idFiglio":19,"chiave":19,"patCur":"/0/8/18/","pathLogico":"/ROOT/IRU/RICHIESTE/","flgFigli":false,"uuid":"44F2B22E289C4C8F8D367609AA5B45F3"},{"livello":3,"cartella":"    ESITI","idPadre":4,"idFiglio":20,"chiave":20,"patCur":"/0/8/6/","pathLogico":"/ROOT/IRU/ESITI/","flgFigli":false,"uuid":"0C7DCC10485540FA837296AAA789F6A8"},{"livello":2,"cartella":"  LAVORI","idPadre":0,"idFiglio":5,"chiave":5,"patCur":"/0/10/","pathLogico":"/ROOT/LAVORI/","flgFigli":true,"uuid":"B99DAEB7B22A48559EE71C9C23CE8C1D"},{"livello":3,"cartella":"    VARIANTI","idPadre":5,"idFiglio":21,"chiave":21,"patCur":"/0/10/23/","pathLogico":"/ROOT/LAVORI/VARIANTI/","flgFigli":false,"uuid":"42BA1022661042658BCF278B8C8A2535"},{"livello":3,"cartella":"    PRODUZIONE","idPadre":5,"idFiglio":22,"chiave":22,"patCur":"/0/10/15/","pathLogico":"/ROOT/LAVORI/PRODUZIONE/","flgFigli":false,"uuid":"0E4A564D7DEC4DCF9E938FE64F227228"},{"livello":3,"cartella":"    VARIE","idPadre":5,"idFiglio":23,"chiave":23,"patCur":"/0/10/24/","pathLogico":"/ROOT/LAVORI/VARIE/","flgFigli":false,"uuid":"C1F66DE9AEED4817A2EEE7BF2E041AF9"},{"livello":2,"cartella":"  ASBUILT","idPadre":0,"idFiglio":6,"chiave":6,"patCur":"/0/3/","pathLogico":"/ROOT/ASBUILT/","flgFigli":true,"uuid":"1DA0268935B046FB9D217E092E43FE5C"},{"livello":3,"cartella":"    OUTPUT","idPadre":6,"idFiglio":24,"chiave":24,"patCur":"/0/3/12/","pathLogico":"/ROOT/ASBUILT/OUTPUT/","flgFigli":true,"uuid":"8AB453C659894AD5A130E09B71A5A3AA"},{"livello":4,"cartella":"      PLANIMETRIA","idPadre":24,"idFiglio":25,"chiave":25,"patCur":"/0/3/12/14/","pathLogico":"/ROOT/ASBUILT/OUTPUT/PLANIMETRIA/","flgFigli":false,"uuid":"B037B0C8AD614C539163F2CDD8D45D7E"},{"livello":4,"cartella":"      SINOTTICO","idPadre":24,"idFiglio":26,"chiave":26,"patCur":"/0/3/12/20/","pathLogico":"/ROOT/ASBUILT/OUTPUT/SINOTTICO/","flgFigli":false,"uuid":"2C651C4C1DD648158BB4B442B067EDCD"},{"livello":4,"cartella":"      QUANTITA_ELENCO_MATERIALI","idPadre":24,"idFiglio":27,"chiave":27,"patCur":"/0/3/12/17/","pathLogico":"/ROOT/ASBUILT/OUTPUT/QUANTITA_ELENCO_MATERIALI/","flgFigli":false,"uuid":"4E383974CC4540AFB490AEE6B9DDCC5C"},{"livello":4,"cartella":"      TABELLA_SINTESI","idPadre":24,"idFiglio":28,"chiave":28,"patCur":"/0/3/12/22/","pathLogico":"/ROOT/ASBUILT/OUTPUT/TABELLA_SINTESI/","flgFigli":false,"uuid":"AB57850F94B6483BBD994D3DA5DABBBB"},{"livello":4,"cartella":"      AREE_INFLUENZA","idPadre":24,"idFiglio":29,"chiave":29,"patCur":"/0/3/12/2/","pathLogico":"/ROOT/ASBUILT/OUTPUT/AREE_INFLUENZA/","flgFigli":false,"uuid":"3DA7B96D1DA94EDAAEFD1F847D71348A"},{"livello":4,"cartella":"      AGG_TERMINALI_RAME","idPadre":24,"idFiglio":30,"chiave":30,"patCur":"/0/3/12/1/","pathLogico":"/ROOT/ASBUILT/OUTPUT/AGG_TERMINALI_RAME/","flgFigli":false,"uuid":"F152AD8A33C54C5FAA960C3C743D0A76"},{"livello":3,"cartella":"    MISURE_CANTIERE","idPadre":6,"idFiglio":31,"chiave":31,"patCur":"/0/3/11/","pathLogico":"/ROOT/ASBUILT/MISURE_CANTIERE/","flgFigli":false,"uuid":"635669CF47264C08BA7B97BC296DDC92"},{"livello":3,"cartella":"    VARIE","idPadre":6,"idFiglio":32,"chiave":32,"patCur":"/0/3/24/","pathLogico":"/ROOT/ASBUILT/VARIE/","flgFigli":false,"uuid":"CE8AFCA8990A4523839A0549C60BBB8F"}  
  ];

  // public fields: Object = { dataSource: this.data, value: 'chiave', text: 'cartella', parentValue: "idPadre", hasChildren: 'flgFigli' };
  public fields: Object;


  tabCheck: number = 1
  spinner: boolean = false;
  lockPrj: boolean = false;
  msgs = false;
  flgPrjLibero = false;
  // flgAdmin = false;
  message: string = null;
  chiave_categoria = "1";
  projectModalCloseResult: string = '';
  fileModalCloseResult: string = '';
  fileSelected: string = '';
  userLogin = JSON.parse(localStorage.getItem('tabUser'))
  isOnlyAdmin: boolean = JSON.parse(localStorage.getItem('isOnlyAdmin'))
  loginUserProfile: number = 0
  loadUserProjectIN = new LoadUserProjectIN()
  loadUserForProjectIN = new LoadUserProjectIN()
  listUserProjectPrj: ViwUserProfileMobile[] = []
  listUserByPrj: ViwUserProfileMobilePrj[] = []
  associateUserPrjIN = new AssociateUserPrjIN()
  listProject: any[] = []
  viwStati: ViwStati[] = []
  listPrjStati: ViwRelProgettoStati[] = []
  listCategorie: ViwFolderTree[] = []
  listFolderFile: RelProjectFolder[] = []

  project: ViwProjectModel = new ViwProjectModel();
  editProjectIN: ViwProjectModel = new ViwProjectModel();
  deleteFileINModel: DeleteFileINModel = new DeleteFileINModel();
  loadListFileINModel: LoadListFileIN = new LoadListFileIN();
  uploadFileIN: UploadFileINModel = new UploadFileINModel();

  projectFormEdit: FormGroup;
  projectFormAss: FormGroup;
  projectFormStati: FormGroup;
  projectFormDoc: FormGroup;
  dmsFormFile: FormGroup;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  toRev: NgbDate | null;

  modifyProgettoINModel = new ModifyProgettoINModel()
  loadComuniINModel = new LoadComuniINModel()

  selectIdRegione: string = ''
  selectIdProvincia: string = ''
  selectIdComune: string = ''

  cluster: boolean = false
  selUser: boolean = false
  centraleAclrr: boolean = false
  desAdcModify: string = ''
  codeAclrrModify: string = ''
  checkEdit: boolean = false

  loadingIndicator = true;
  reorderable = true;
  ColumnMode = ColumnMode;

  modalCloseResult: string = '';

  listViwComuni: ListViwClusterModel[] = []
  listViwCentrali: ListViwClusterModel[] = []
  rowsCluster = []
  rowsAssocUser: ViwUserProfileMobilePrj[] = []
  rowsAssocUserTMP = []
  listIdProfile: TabProfileModel[] = []
  listIdUser: ViwUserProfileMobile[] = []
  updateStato = new RelProgettoStatiIN()
  selectIdUser: number
  valGeoJson: string = ''
  valGeoLayer: string = ''
  configListLayer: ViwLayerModel[] = []

  profili: TabProfileModel[] = [{ 'name': 'Amministratore', 'id': 1 }, { 'name': 'Project Manager', 'id': 2 }, { 'name': 'Progettista', 'id': 3 }, { 'name': 'Assistente', 'id': 4 }]

  modifytProgettoIN = new ModifyProgettoINModel()
  modifyProject = {
    tabProgetto: {
      codiceArmadio: undefined,
      codiceCentrale: undefined,
      codiceIdProgetto: undefined,
      codiceNetwork: undefined,
      dataCreazione: undefined,
      dataFine: undefined,
      dataInizio: undefined,
      descrizione: undefined,
      flagConvalidato: false,
      idCluster: undefined,
      idProgetto: undefined,
      idUser: undefined,
      idUserLock: undefined,
      istatComune: undefined,
      valGeoPrj: undefined,
      dataRevisione: undefined,
      descAggiornameto: undefined,
      descRevisone: undefined,
    }
  }

  public treeData: any[] = [{
    name: "folder",
    isOpen: true,
    iconSelector: "computer",
    nameSelector: "warning",
    nodes: [{
      name: 'file'
    }]
  }, {
    name: 'another folder',
    nodes: [{
      name: 'another file'
    }]
  }];

  public treeConfig: any = {
    dataMap: {
      children: "nodes"
    }
  }


  public config: DropzoneConfigInterface = {
    url: 'https://httpbin.org/post',
    clickable: true,
    maxFiles: 2,
    autoReset: null,
    errorReset: null,
    cancelReset: null,
    acceptedFiles: '.pdf,.docx'
  };

  @ViewChild(DropzoneDirective, { static: false }) directiveRef?: DropzoneDirective;


  areaArmadioLayer: any[];
  insertPlanimetriaOUT = new InsertPlanimetriaOUTModel()
  printSinotticoOUT = new PrintSinotticoOUTModel()
  reportStatusOUT = new ReportStatusOUTModel()
  dowloadPrintOUT = new DowloadPrintOUTModel()

  dateModel: {
    year: string,
    month: string,
    day: string
  }

  constructor(
    private projectService: ProjectService,
    private reportService: ReportService,
    private dmsService: DmsService,
    private modalService: NgbModal,
    private calendar: NgbCalendar, public formatter: NgbDateParserFormatter,
    private configService: ConfigService, private mapService: MapService) {

    this.profileLoginUser()
    this.project = JSON.parse(localStorage.getItem('projectSelected'));
    this.editProjectIN = JSON.parse(localStorage.getItem('projectSelected'));
    console.log("PROJECT DETAIL::", this.project)

    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngOnInit(): void {

    this.projectFormEdit = new FormGroup({
      codiceArmadio: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
      descrizione: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
      codiceIdProgetto: new FormControl(null, [Validators.minLength(1), Validators.maxLength(100)]),
      codiceNetwork: new FormControl(null, [Validators.minLength(1), Validators.maxLength(100)]),
      dataFine: new FormControl(null),
      dataInizio: new FormControl(null),
      idAclrr: new FormControl(null, [Validators.required]),
      idComune: new FormControl(null, [Validators.required]),
      dataRevisione: new FormControl(null),
      descAggiornameto: new FormControl(null),
      descRevisone: new FormControl(null),
    })

    this.projectFormAss = new FormGroup({
      listIdProfile: new FormControl(null, [Validators.required]),
      listIdUser: new FormControl(null, [Validators.required])
    })

    this.projectFormDoc = new FormGroup({
      listCategorie: new FormControl(null, [Validators.required]),
      note: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(50)]),
    })

    this.dmsFormFile = new FormGroup({
      file: new FormControl(null, [Validators.required]),
      listCategorie: new FormControl(null, [Validators.required]),
      note: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(50)]),
    })

    this.projectFormStati = new FormGroup({
      note: new FormControl('', [Validators.minLength(1), Validators.maxLength(50)]),
      listStati: new FormControl(null, [Validators.required])
    })

    this.flgPrjLibero = this.project.idUserLock == null ? true : false

    this.modifyProject.tabProgetto.idUser = this.project.idUser
    this.modifyProject.tabProgetto.codiceArmadio = this.editProjectIN.codiceArmadio
    this.modifyProject.tabProgetto.codiceIdProgetto = this.editProjectIN.codiceIdProgetto
    this.modifyProject.tabProgetto.codiceNetwork = this.editProjectIN.codiceNetwork
    this.modifyProject.tabProgetto.idUserLock = this.project.idUserLock
    var dataF = this.editProjectIN.dataFine + ""
    if (this.editProjectIN.dataFine == null || dataF.length == 0) {
      this.modifyProject.tabProgetto.dataFine = ""
    } else {
      this.modifyProject.tabProgetto.dataFine = dataF.substring(0, 10)
    }
    var dataI = this.editProjectIN.dataInizio + ""
    if (this.editProjectIN.dataInizio == null || dataI.length == 0) {
      this.modifyProject.tabProgetto.dataInizio = ""
    } else {
      this.modifyProject.tabProgetto.dataInizio = dataI.substring(0, 10)
    }
    this.modifyProject.tabProgetto.descrizione = this.editProjectIN.descrizione
    this.modifyProject.tabProgetto.flagConvalidato = this.editProjectIN.flagConvalidato
    this.modifyProject.tabProgetto.idCluster = this.editProjectIN.idCluster
    this.modifyProject.tabProgetto.dataCreazione = "" + this.editProjectIN.dataCreazione
    this.modifyProject.tabProgetto.idProgetto = this.editProjectIN.idProgetto
    this.modifyProject.tabProgetto.istatComune = this.editProjectIN.istatComune
    this.modifyProject.tabProgetto.codiceCentrale = this.editProjectIN.codiceCentrale

    this.modifyProject.tabProgetto.dataRevisione = this.editProjectIN.dataRevisione

    this.modifyProject.tabProgetto.descAggiornameto = this.editProjectIN.descAggiornameto
    this.modifyProject.tabProgetto.descRevisone = this.editProjectIN.descRevisone

    this.updateStato.idUser = this.userLogin.idUser
    this.updateStato.idProgetto = this.project.idProgetto
    this.updateStato.note = ''

    this.getAllData();
    this.getAllDataAssocUtenti();
    this.onSelectCluster(this.editProjectIN)
  }

  getAllData() {
    this.spinner = true

    let listComuni = this.configService.loadComuniFromCluster()
    let filterClusterIN = {
      idComune: this.editProjectIN.istatComune.toString()
    }
    let loadUserProjIN = {
      idProgetto: this.project.idProgetto
    }
    let listAclrr = this.configService.loadAclrrClusterById(filterClusterIN)

    let listUserAss = this.projectService.loadUserProject(loadUserProjIN)

    this.loadViwStati()
    this.loadViwProgettoStati()
    this.loadListViwFolderTree()
    //  this.loadListFile()

    forkJoin(listComuni, listAclrr, listUserAss).subscribe(response => {
      this.spinner = false
      this.loadingIndicator = false;

      if (response[0] != null) {
        let res = response[0];
        this.listViwComuni = res.listViwCluster;
      }
      if (response[1] != null) {
        let res = response[1];
        this.listViwCentrali = res.viwClustersList;
        this.centraleAclrr = true

        for (let i of this.listViwCentrali) {
          if (this.modifyProject.tabProgetto.codiceCentrale.includes(i.codAclrr)) {
            this.checkEdit = true
            this.desAdcModify = i.desAdc
            this.codeAclrrModify = i.codAclrr
          }
        }
      }
      if (response[2] != null) {
        let res = response[2];
        this.rowsAssocUser = res.listUserProjectPrj;
        this.rowsAssocUserTMP = this.rowsAssocUser
      }
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      this.messageBox('error', JSON.stringify(err))
    });
  }

  getAllDataAssocUtenti() {
    this.spinner = true

    let listComuni = this.configService.loadComuniFromCluster()
    let filterClusterIN = {
      idComune: this.editProjectIN.istatComune.toString()
    }
    let listAclrr = this.configService.loadAclrrClusterById(filterClusterIN)

    forkJoin(listComuni, listAclrr).subscribe(response => {
      this.spinner = false
      this.loadingIndicator = false;

      if (response[0] != null) {
        let res = response[0];
        this.listViwComuni = res.listViwCluster;
      }
      if (response[1] != null) {
        let res = response[1];
        this.listViwCentrali = res.viwClustersList;
        this.centraleAclrr = true

        for (let i of this.listViwCentrali) {
          if (this.modifyProject.tabProgetto.codiceCentrale.includes(i.codAclrr)) {
            this.checkEdit = true
            this.desAdcModify = i.desAdc
            this.codeAclrrModify = i.codAclrr
          }
        }
      }
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      //this.msgs = true
      //this.message = JSON.stringify(err)
      this.messageBox('error', JSON.stringify(err))
    });
  }

  onSelectComune(event) {
    this.checkEdit = false
    this.rowsCluster = []
    this.listViwCentrali = []
    this.modifyProject.tabProgetto.codiceCentrale = null

    let filterClusterIN = {
      idComune: event.idComune.toString()
    }
    this.configService.loadAclrrClusterById(filterClusterIN).subscribe((res) => {
      this.spinner = false
      this.listViwCentrali = res.viwClustersList
      console.log("LISTA CENTRALI::", this.listViwCentrali)
      this.centraleAclrr = true
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      //this.msgs = true
      //this.message = JSON.stringify(err)
      this.messageBox('error', JSON.stringify(err))
    });
  }

  onSelectUserProfile(event) {
    if (event != undefined) {
      this.spinner = true
      this.listIdUser = []
      //this.selectIdUser = null
      this.projectFormAss.controls.listIdUser.reset()

      let loadUserProjectIN = {
        idProfile: event.id,
        idProgetto: this.editProjectIN.idProgetto
      }

      this.projectService.loadUserForProject(loadUserProjectIN).subscribe((res) => {
        this.spinner = false
        this.listUserByPrj = res.listUserProject
        // this.loadUserProject(event.idUser)

      }, (err: HttpErrorResponse) => {
        this.spinner = false
        //this.msgs = true
        //this.message = JSON.stringify(err)
        this.messageBox('error', JSON.stringify(err))
      });
    }
  }

  onSelectCluster(event) {
    this.checkEdit = false
    this.cluster = true
    this.rowsCluster = []
    this.rowsCluster.push(event)
    this.modifyProject.tabProgetto.idCluster = event.idCluster
  }

  onSelectUser(event) {
    this.selUser = true

    if (this.rowsAssocUser.length > 0) {
      for (let i = 0; i < this.rowsAssocUser.length; i++) {
        if (event.idUser == this.rowsAssocUser[i].idUser) {
          this.rowsAssocUser.splice(i, 1)
        }
      }
      for (let i of this.listUserByPrj) {
        if (i.idUser == this.selectIdUser) {
          if (this.rowsAssocUser.indexOf(i) == -1) {

            this.rowsAssocUser.push(i)
            this.rowsAssocUserTMP = this.rowsAssocUser
            this.rowsAssocUser = [...this.rowsAssocUser]
            // console.log("ROWS USER:: " + JSON.stringify(this.rowsAssocUser))
          }
        }
      }
    }
    else {
      for (let i of this.listUserByPrj) {
        if (i.idUser == this.selectIdUser) {
          if (this.rowsAssocUser.indexOf(i) == -1) {
            this.rowsAssocUser.push(i)
            this.rowsAssocUserTMP = this.rowsAssocUser
            this.rowsAssocUser = [...this.rowsAssocUser]
            console.log("ROWS USER:: " + JSON.stringify(this.rowsAssocUser))
          }
        }
      }
    }
  }

  updateFilter(event) {
    const v = event.target.value.toLowerCase();
    const t = this.rowsAssocUserTMP.filter(function (d) {
      return d.desSurname.toLowerCase().indexOf(v) !== -1 || !v;
    });
    this.rowsAssocUser = t;
  }

  removeRow(index) {
    this.rowsAssocUser.splice(index, 1);
    this.rowsAssocUserTMP = this.rowsAssocUser
    this.rowsAssocUser = [...this.rowsAssocUser]

  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  onDateRevSelection(date: NgbDate) {
    if (!this.toRev) {
      this.toRev = date;
    } else if (this.toRev && date && date.after(this.toRev)) {
      this.toRev = date;
    } else {
      this.toRev = date;
    }
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    console.log("DENTRO VALIDATE::", input)
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  profileLoginUser() {
    let profili: any[] = []
    for (let item of this.userLogin.listUserGrant) {
      profili = item.listUserProfileObject
    }
    for (let i of profili) {
      if (i.id == 1) {
        this.loginUserProfile = i.id
        break
      } else if (i.id == 2) {
        this.loginUserProfile = i.id
        break
      }
    }
  }

  tabButton(check: number) {
    this.tabCheck = check
  }

  messageBox(operation, message) {
    if (operation == "success") {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: message,
        showConfirmButton: false,
        timer: 1500
      })
    }
    if (operation == "error") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: message,
        showConfirmButton: true,
      })
    }
    if (operation == "info") {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: message,
        showConfirmButton: true,
      })
    }
  }

  loadUserProject(idUser) {
    console.log(idUser)
    this.spinner = true
    this.msgs = false
    this.message = ''

    let loadUserProjIN = {
      idProgetto: this.project.idProgetto
    }

    this.projectService.loadUserProject(loadUserProjIN).subscribe((res) => {
      this.spinner = false
      this.rowsAssocUser = res.listUserProjectPrj
      console.log("LISTA PROGETTI USER::", JSON.stringify(res))

      this.loadingIndicator = false;
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      /*this.msgs = true
      this.message = JSON.stringify(err)*/
      this.messageBox('error', JSON.stringify(err))
    });
  }

  associateUserProject() {
    this.spinner = true
    this.msgs = false
    this.message = ''
    this.associateUserPrjIN.listIdUser = []
    if (this.rowsAssocUser.length > 0) {
      for (let i = 0; i < this.rowsAssocUser.length; i++) {
        this.associateUserPrjIN.listIdUser.push(this.rowsAssocUser[i].idUser)
      }
    } else this.associateUserPrjIN.listIdUser = []
    this.associateUserPrjIN.idProgetto = this.project.idProgetto

    this.projectService.associateUserProject(this.associateUserPrjIN).subscribe((res) => {
      this.spinner = false
      this.message = "Operazione avvenuta con successo"
      this.messageBox('success', this.message)
      this.loadingIndicator = false;
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      /*this.msgs = true
      this.message = JSON.stringify(err)*/
      this.messageBox('error', JSON.stringify(err))
    });
  }

  lockUnlock(prj: any) {
    console.log(prj)
    this.flgPrjLibero = true

    if (prj.idUserLock == null) {
      prj.idUserLock = this.userLogin.idUser
      this.modifyProject.tabProgetto.idUserLock = prj.idUserLock
    } else {
      prj.idUserLock = null
      this.modifyProject.tabProgetto.idUserLock = null
    }

    // if (this.isOnlyAdmin) {
    //   this.flgAdmin = true
    // }

    this.modificaProgetto()

  }

  parseDataAttribute(data) {
    var day, month
    if (data.day < 10) {
      day = '0' + data.day
    } else {
      day = '' + data.day
    }
    if (data.month < 10) {
      month = '0' + data.month
    } else {
      month = '' + data.month
    }
    var date: string = data.year + '-' + month + '-' + day
    return date
  }

  parseObjData(data) {
    var splitted = data.split("-", 3);
    this.dateModel = {
      year: splitted[0],
      month: splitted[1],
      day: splitted[2]

    }
    let ngbDate = this.validateInput(null, data)
    return ngbDate
  }

  modificaProgetto() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    this.modifyProject.tabProgetto.dataInizio = this.formatter.format(this.fromDate)
    this.modifyProject.tabProgetto.dataFine = this.formatter.format(this.toDate)
    this.modifyProject.tabProgetto.dataRevisione = this.formatter.format(this.toRev)

    console.log("MODIFICA PROGETTO::", this.modifyProject)

    this.projectService.modifyProgetto(this.modifyProject).subscribe((res) => {
      this.spinner = false
      this.message = "Progetto modificato correttamente"
      this.messageBox('success', this.message)

      this.loadingIndicator = false;
      this.loadViwProgettoStati()
      this.projectFormStati.controls.listStati.reset()
      this.projectFormStati.controls.note.reset()

      localStorage.setItem('projectSelected', JSON.stringify(res.tabProgetto))
      this.project = JSON.parse(localStorage.getItem('projectSelected'))
      this.editProjectIN = JSON.parse(localStorage.getItem('projectSelected'))
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      this.messageBox('error', JSON.stringify(err))
    });
  }

  insertRelProgettoStati() {
    this.spinner = true

    this.projectService.insertRelProgettoStati(this.updateStato).subscribe((res) => {
      this.spinner = false
      this.message = "Operazione avvenuta con successo"
      this.messageBox('success', this.message)
      this.loadingIndicator = false;
      this.loadViwProgettoStati()
      this.projectFormStati.controls.listStati.reset()
      this.projectFormStati.controls.note.reset()
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      this.messageBox('error', JSON.stringify(err))
    });
  }

  loadViwStati() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    this.projectService.loadViwStati().subscribe((res) => {
      this.spinner = false
      this.viwStati = res.listViwStati
      this.loadingIndicator = false;
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      /*this.msgs = true
      this.message = JSON.stringify(err)*/
      this.messageBox('error', JSON.stringify(err))
    });
  }

  loadViwProgettoStati() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let modelViwPrjStati = {
      idProgetto: this.project.idProgetto
    }

    this.projectService.loadViwProgettoStati(modelViwPrjStati).subscribe((res) => {
      this.spinner = false
      this.listPrjStati = res.listViwRelProgettoStati
      for (let i = 0; i < res.listViwRelProgettoStati.length; i++) {
        res.listViwRelProgettoStati[i].autore = res.listViwRelProgettoStati[i].desName + ' ' + res.listViwRelProgettoStati[i].desSurname
      }
      this.loadingIndicator = false;
      this.loadProjectById()
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      /*this.msgs = true
      this.message = JSON.stringify(err)*/
      this.messageBox('error', JSON.stringify(err))
    });
  }

  loadListViwFolderTree() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    this.dmsService.loadListViwFolderTree().subscribe((res) => {
      this.spinner = false
      this.data = res.listViwFolderTree

      this.fields = { dataSource: this.data, value: 'chiave', text: 'cartella', parentValue: "idPadre", hasChildren: 'flgFigli' };

      this.loadingIndicator = false;
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      /*this.msgs = true
      this.message = JSON.stringify(err)*/
      this.messageBox('error', JSON.stringify(err))
    });
  }

  onDropChange(event: any) {
    this.chiave_categoria = event.itemData.id
    this.loadListFile()
  }

  onDropChangeAdd(event: any) {
    this.uploadFileIN.idFolderTree = event.itemData.id
  }

  loadListFile() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    this.loadListFileINModel.idPogetto = this.project.idProgetto
    this.loadListFileINModel.idFolderTree = parseInt(this.chiave_categoria)
    console.log(this.loadListFileINModel)
    this.dmsService.loadListFile(this.loadListFileINModel).subscribe((res) => {
      this.spinner = false
      this.listFolderFile = res.listFolderFile

      for (let i = 0; i < this.listFolderFile.length; i++) {
        this.listFolderFile[i].descSize = this.listFolderFile[i].descSize + ' ' + 'KB'
      }
      this.loadingIndicator = false;
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      /*this.msgs = true
      this.message = JSON.stringify(err)*/
      this.messageBox('error', JSON.stringify(err))
    });
  }



  // onUploadError(event: any): void {
  // console.log('onUploadError:', event);
  // }

  // onUploadSuccess(event: any): void {
  // this.uploadFileIN.file = event[0]
  // console.log('onUploadSuccess:', event);

  // }

  onFileSelect(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadFileIN.file = file;
      console.log(file)

    }
  }

  resetUpload(): void {
    this.dmsFormFile.reset()
    this.loadListViwFolderTree()
  }


  uploadFile() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    this.uploadFileIN.idProgetto = this.project.idProgetto
    console.log(this.uploadFileIN)
    this.dmsService.uploadFile(this.uploadFileIN).subscribe((res) => {
      this.spinner = false
      this.message = "Operazione avvenuta con successo"
      this.messageBox('success', this.message)
      this.loadingIndicator = false;
      this.loadListViwFolderTree()
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      /*this.msgs = true
      this.message = JSON.stringify(err)*/
      this.messageBox('error', JSON.stringify(err))
    });
  }

  downloadFile(downloadFileModal: RelProjectFolder) {
    let load: LoadFileINModel = new LoadFileINModel();
    load.filePath = downloadFileModal.descPath;

    this.dmsService.loadFile(load).subscribe(data => {
      const contentType = "application/octet-stream";
      const b64Data = data.resource;
      const byteCharacters = atob(b64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      var a = document.createElement("a")
      a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));
      a.download = downloadFileModal.descName;
      // start download
      a.click();
    })
  }

  deleteFile(modelDelete: RelProjectFolder, index: number) {
    this.spinner = true
    this.msgs = false
    this.message = ''

    this.deleteFileINModel.filePath = modelDelete.descPath

    this.dmsService.deleteFile(this.deleteFileINModel).subscribe((res) => {
      this.spinner = false
      this.loadingIndicator = false;

      this.loadListFile();
      this.fileSelected = ''

      this.message = "Documento eliminato con successo"
      this.messageBox('success', this.message)
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      this.messageBox('error', JSON.stringify(err))
    });
  }

  openCheckPrjModal(content, prj: any, event) {
    this.loadingIndicator = true
    this.modalService.open(content).result.then((result) => {
      this.modalCloseResult = "Modal closed" + result
      if (result == 'by: save button') {
        this.lockUnlock(prj)
      } else {
        //reset Modifica Progetto
        event.target.checked = !event.target.checked
        //this.loadViwProgettoStati()
      }
    }).catch((res) => { });
  }

  openAddFileModal(content) {
    this.loadingIndicator = true
    this.modalService.open(content).result.then((result) => {
      this.modalCloseResult = "Modal closed" + result
      if (result == 'by: save button') {
        this.uploadFile();
        this.resetUpload()
        // this.projectFormDoc.reset();
      } else {
        this.resetUpload()
        // this.projectFormDoc.reset();
      }
    }).catch((res) => { });
  }

  openDeleteFileModal(content, indexRow, rowSelected) {
    this.fileSelected = ''
    this.fileSelected = rowSelected.descName
    this.modalService.open(content, {}).result.then((result) => {
      this.fileModalCloseResult = "Modal closed" + result
      if (result == 'by: delete button') {
        this.deleteFile(rowSelected, indexRow);
      }
    }).catch((res) => { });
  }

  /***************** PROGETTAZIONE SU MAPPA *****************/
  saveAreaArmadio() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let params = JSON.parse(localStorage.getItem('geojson'))

    console.log("INSERT AREA ARMADIO::", params)

    this.mapService.insertAreaArmadio(params).subscribe((res) => {
      this.spinner = false
      this.message = "Operazione avvenuta con successo"
      this.messageBox('success', this.message)
      localStorage.removeItem('geojson')
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      this.message = "Disegnare area armadio prima di salvare"
      this.messageBox('error', this.message)
    });
  }

  updateFeatureLay(event) {
    let geoLay = JSON.parse(this.valGeoLayer)
    let evento = JSON.parse(event)
    geoLay.features.map(feature => {
      if (feature.properties.uid == evento.properties.uid) {
        feature.geometry = evento.geometry
      }
    })
    this.valGeoLayer = JSON.stringify(geoLay)
  }
  /***************** FINE PROGETTAZIONE SU MAPPA *****************/


  /****************** OUTPUT DI PROGETTAZIONE ******************/
  stampaModelloShapeFile() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let createShapeFileIN = {
      idProgetto: this.project.idProgetto,
    }

    this.reportService.createShapeFileZip(createShapeFileIN).subscribe((data) => {
      const contentType = "application/zip";
      const b64Data = data.resource;
      const byteCharacters = atob(b64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      var a = document.createElement("a")
      a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));
      a.download = data.fileName;
      // start download
      a.click();
      this.spinner = false
    }, (err: HttpErrorResponse) => {
      this.messageBox('error', err)
      this.spinner = false
    });
  }

  stampaModelloAIFO() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let date = this.currentData()

    let load: StampaModelloOtticaIN = new StampaModelloOtticaIN();
    load.idProgetto = this.project.idProgetto

    this.projectService.stampaModelloAIFO(load).subscribe((data) => {
      const contentType = "application/octet-stream";
      const b64Data = data.resource;
      const byteCharacters = atob(b64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      var a = document.createElement("a")
      a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));
      a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + "_Modello_AI_FO" + '.xls';
      // start download
      a.click();
      this.spinner = false
    }, (err: HttpErrorResponse) => {
      this.messageBox('error', err)
      this.spinner = false
    });
  }

  stampaModelloRame() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let load: StampaModelloRameIN = new StampaModelloRameIN();
    load.idProgetto = this.project.idProgetto

    let date = this.currentData()

    this.projectService.stampaModelloRame(load).subscribe((data) => {
      const contentType = "application/octet-stream";
      const b64Data = data.resource;
      const byteCharacters = atob(b64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      var a = document.createElement("a")
      a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));
      a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + "_Modello_AI_Rame" + '.xls';
      // start download
      a.click();
      this.spinner = false
    }, (err: HttpErrorResponse) => {
      this.messageBox('error', err)
      this.spinner = false
    });
  }

  stampaModelloPreventivo() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let load: StampaModelloPreventivoIN = new StampaModelloPreventivoIN();
    load.idProgetto = this.project.idProgetto

    let date = this.currentData()

    this.projectService.stampaModelloPreventivo(load).subscribe((data) => {
      const contentType = "application/octet-stream";
      const b64Data = data.resource;
      const byteCharacters = atob(b64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      var a = document.createElement("a")
      a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));
      a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + "_Modello_Preventivo" + '.xlsx';
      // start download
      a.click();
      this.spinner = false
    }, (err: HttpErrorResponse) => {
      this.messageBox('error', err)
      this.spinner = false
    });
  }

  stampaModelloCatalogo() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let GetStatusCatalogoINModel = {
      idProgetto: this.project.idProgetto
    }

    let date = this.currentData()

    const subscription = interval(5000)
      .pipe(
        switchMap(() =>
          this.projectService.getStatusCatalogo(GetStatusCatalogoINModel)
        ),
        takeWhile(({ status }) => {
          console.log("STATUS::", status)
          return status != 1;
        })
      ).subscribe(
        () => { },
        (err: HttpErrorResponse) => {
          this.messageBox('error', err)
          this.spinner = false
        },
        () => {
          let catalogo: ExportCatalogoINModel = new ExportCatalogoINModel();
          catalogo.idProgetto = this.project.idProgetto

          this.projectService.exportCatalogo(catalogo).subscribe((data) => {
            const contentType = "application/octet-stream";
            const b64Data = data.resource;
            const byteCharacters = atob(b64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            var a = document.createElement("a")
            a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));
            a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + "_Catalogo" + '.xlsx';
            // start download
            a.click();
            this.spinner = false
          }, (err: HttpErrorResponse) => {
            this.messageBox('error', err)
            this.spinner = false
          });
        });
  }

  stampaModelloMisure() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let getStatusMisureINModel = {
      idProgetto: this.project.idProgetto
    }

    let date = this.currentData()

    const subscription = interval(5000)
      .pipe(
        switchMap(() =>
          this.reportService.getStatusMisure(getStatusMisureINModel)
        ),
        takeWhile(({ status }) => {
          console.log("STATUS::", status)
          return status != 1;
        })
      ).subscribe(
        () => { },
        (err: HttpErrorResponse) => {
          this.messageBox('error', err)
          this.spinner = false
        },
        () => {
          let misure: DownloadMisureINModel = new DownloadMisureINModel();
          misure.idProgetto = this.project.idProgetto

          this.reportService.downloadMisure(misure).subscribe((data) => {
            const contentType = "application/octet-stream";
            const b64Data = data.resource;
            const byteCharacters = atob(b64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            var a = document.createElement("a")
            a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));
            a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + "_Misure" + '.xlsx';
            // start download
            a.click();
            this.spinner = false
          }, (err: HttpErrorResponse) => {
            this.messageBox('error', err)
            this.spinner = false
          });
        });
  }

  stampaModelloPlanimetria() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let loadAreaArmadioIN = {
      idProgetto: this.project.idProgetto
    }
    this.mapService.loadAreaArmadio(loadAreaArmadioIN).subscribe(data => {
      let vectorSource = this.mapService.createVectorSource(data);
      this.areaArmadioLayer = vectorSource.getExtent()

      let insertPlanimetriaIN = {
        bbox: this.areaArmadioLayer,
        idProgetto: this.project.idProgetto,
        scala: this.mapService.getScalaPlanimetria(this.areaArmadioLayer)
      }

      this.reportService.insertPlanimetria(insertPlanimetriaIN).subscribe((res) => {
        this.insertPlanimetriaOUT = res
        this.longPolling(this.insertPlanimetriaOUT, 'planimetria')
      }, (err: HttpErrorResponse) => {
        this.messageBox('error', err)
        this.spinner = false
      });

    })
  }

  stampaModelloSinottico() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let printSinotticoIN = {
      idProgetto: this.project.idProgetto,
    }
    this.reportService.printSinottico(printSinotticoIN).subscribe((res) => {
      this.printSinotticoOUT = res
      this.longPolling(this.printSinotticoOUT, 'sinottico')
    }, (err: HttpErrorResponse) => {
      this.spinner = false
      this.messageBox("error", err)
    });
  }

  stampaModelloPlanimetriaShape() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let loadAreaArmadioIN = {
      idProgetto: this.project.idProgetto
    }
    this.mapService.loadAreaArmadio(loadAreaArmadioIN).subscribe(data => {
      let vectorSource = this.mapService.createVectorSource(data);
      this.areaArmadioLayer = vectorSource.getExtent()

      let insertPlanimetriaIN = {
        bbox: this.areaArmadioLayer,
        idProgetto: this.project.idProgetto,
        scala: this.mapService.getScalaPlanimetria(this.areaArmadioLayer)
      }
      this.reportService.insertPlanimetriaSHP(insertPlanimetriaIN).subscribe((res) => {
        this.insertPlanimetriaOUT = res
        this.longPolling(this.insertPlanimetriaOUT, 'planimetriaShape')
      }, (err: HttpErrorResponse) => {
        this.messageBox('error', err)
        this.spinner = false
      });
    })
  }

  stampaModelloDisallineamento() {
    this.spinner = true
    this.msgs = false
    this.message = ''

    let loadAreaArmadioIN = {
      idProgetto: this.project.idProgetto
    }
    this.mapService.loadAreaArmadio(loadAreaArmadioIN).subscribe(data => {
      let vectorSource = this.mapService.createVectorSource(data);
      this.areaArmadioLayer = vectorSource.getExtent()

      let insertPlanimetriaIN = {
        bbox: this.areaArmadioLayer,
        idProgetto: this.project.idProgetto,
        scala: this.mapService.getScalaPlanimetria(this.areaArmadioLayer)
      }
      this.reportService.insertPlanimetriaDIS(insertPlanimetriaIN).subscribe((res) => {
        this.insertPlanimetriaOUT = res
        this.longPolling(this.insertPlanimetriaOUT, 'disallineamenti')
      }, (err: HttpErrorResponse) => {
        this.messageBox('error', err)
        this.spinner = false
      });
    })
  }

  longPolling(obj: any, source: string) {
    let date = this.currentData()

    let insertIN = {
      print: obj.ref
    }
    let error = false
    const subscription = interval(5000)
      .pipe(
        switchMap(() =>
          this.reportService.getStatus(insertIN)
        ),
        takeWhile(({ done, status }) => {
          error = status == 'error'
          console.log("STATUS::", done)
          return !done;
        })
      )
      .subscribe(
        _ => { },
        _ => { },
        () => {
          if (error) {
            this.messageBox('error', "Errore Generico. Impossibile scaricare")
            return
          }
          let dowloadPrintIN = {
            print: obj.ref
          }
          this.reportService.dowloadReport(dowloadPrintIN).subscribe((res) => {
            const contentType = "application/octet-stream";
            const b64Data = res.resource;
            const byteCharacters = atob(b64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            var a = document.createElement("a")
            a.href = URL.createObjectURL(new Blob([byteArray], { type: contentType }));

            if (source == 'planimetria') {
              a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + '_Planimetria.pdf';
            } else if (source == 'sinottico') {
              a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + '_Sinottico.pdf';
            } else if (source == 'planimetriaShape') {
              a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + '_Planimetria_Shape.pdf';
            } else if (source == 'disallineamenti') {
              a.download = this.project.codiceCentrale + '_' + this.project.codiceArmadio + '_' + date + '_Disallineamenti.pdf';
            }

            // start download
            a.click();
            this.spinner = false
          }, (err: HttpErrorResponse) => {
            console.log("ERRORE")
            this.spinner = false
          });
        }
      );
  }

  currentData() {
    var today = new Date();
    var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();
    return date
  }

  /****************** FINE OUTPUT DI PROGETTAZIONE ******************/

  /****************** CONVALIDA PROGETTO - CONVALIDA VISIVA ******************/
  graphicValidation() {
    let graphicValidation = {
      idProgetto: this.project.idProgetto
    }
    this.mapService.convalidaVisiva(graphicValidation)
  }

  projectValidation() {
    let projectValidation = {
      inIdProgetto: this.project.idProgetto
    }
    this.mapService.convalidaProgetto(projectValidation)
  }
  /****************** FINE CONVALIDA PROGETTO - CONVALIDA VISIVA ******************/

  /****************** AGGIORNA DATI PROGETTO ******************/
  loadProjectById() {
    this.spinner = true
    let loadProjectByIdINModel = {
      idProgetto: this.project.idProgetto
    }
    this.projectService.loadProjectById(loadProjectByIdINModel).subscribe((res) => {
      this.spinner = false
      localStorage.setItem('projectSelected', JSON.stringify(res.viwProject))
      this.project = JSON.parse(localStorage.getItem('projectSelected'))
      this.editProjectIN = JSON.parse(localStorage.getItem('projectSelected'))

      console.log("PRJECT::", this.project)
    }, (err: HttpErrorResponse) => {
      console.log("ERRORE")
      this.spinner = false
    });
  }
}